<template>
    <div class="main-footer grid grid__base">
        <div class="main-footer--container grid--container">
            <div class="main-footer--row grid--row">
                <div class="grid--col main-footer--logo">
                    <app-logo theme="light" :link="{path: '/', label: 'home'}"/>
                </div>
                <compontent
                        class="grid--col"
                        v-for="(plugin, index) in plugins"
                        :key="index"
                        :is="plugin.type"
                        v-bind="bindCmsPluginAttrs(plugin)"/>
                
            </div>
        </div>
    </div>
</template>

<script>
    import { bindCmsPluginAttrs } from 'util/vue/django-cms-spa';
    import AppLogo from 'framework/components/app-logo/app-logo';

    export default {
        components: { AppLogo },
        props: {
            /** @type {IAbstractPlugin][]} */
            plugins: {
                type: Array,
                required: true,
            },
        },
        methods: {
            bindCmsPluginAttrs,
        },
    };
</script>
